<template>
  <div>
    <h4>{{ $t('accounts.schedule.title') }}</h4>
    <timezone-input v-model="timezone" :config="timezoneInput"></timezone-input>

    <v-dialog
      v-model="modal" lazy>
      <v-btn
        slot="activator"
        outline primary>
        {{ $t('accounts.schedule.add') }}
      </v-btn>

      <v-card>
        <v-card-title>
          {{ $t('accounts.schedule.addTitle') }}
        </v-card-title>
        <v-card-text>
          <week-day-input
            v-model="newTime.day"
            :config="{ required: true, label: $t('accounts.schedule.header.day') }">
          </week-day-input>
          <time-input
            v-model="newTime.from"
            :config="{ required: true, label: $t('accounts.schedule.header.from') }">
          </time-input>
          <time-input
            v-model="newTime.to"
            :config="{ required: true, label: $t('accounts.schedule.header.to') }">
          </time-input>
          <v-btn
            primary block light
            @click.native.stop="add()">
            {{ $t('accounts.schedule.addThis') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-data-table
      class="schedule-table"
      :headers="headers"
      :items="schedule"
      :custom-sort="sort"
      hide-actions>
      <template slot="items" scope="props">
        <td>
          <week-day-input
            v-model="props.item.day"
            :config="required">
          </week-day-input>
        </td>
        <td>
          <time-input
            v-model="props.item.from"
            :config="required">
          </time-input>
        </td>
        <td>
          <time-input
            v-model="props.item.to"
            :config="required">
          </time-input>
        </td>
        <td width="1em">
          <v-btn
            flat icon primary
            @click.native.stop="remove(props.item)">
            <v-icon>close</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <v-card-row actions>
      <v-btn
        type="submit"
        primary light ripple
        :loading="loading"
        @click.native.stop="submit()">
        {{ $t('accounts.schedule.save') }}
      </v-btn>
    </v-card-row>
  </div>
</template>

<script>
  import currentExpert from '@/mixins/currentExpert'
  import { TimezoneInput, TimeInput, WeekDayInput } from '@/components/inputs'
  
  const valid = (x) => x.from !== null && x.to !== null
  
  export default {
    mixins: [currentExpert],
    components: {
      TimezoneInput,
      TimeInput,
      WeekDayInput
    },
    data () {
      return {
        error: {},
        timezone: this.expert.timezone,
        newTime: { day: null, from: null, to: null },
        schedule: [...this.expert.schedule],
        modal: false
      }
    },
    computed: {
      required () { return { required: true } },
      headers () {
        return [
          { text: this.$t('accounts.schedule.header.day'), left: true, sortable: false },
          { text: this.$t('accounts.schedule.header.from'), left: true, sortable: false },
          { text: this.$t('accounts.schedule.header.to'), left: true, sortable: false },
          { text: '', left: true, sortable: false }
        ]
      },
      timezoneInput () {
        return {
          key: 'timezone',
          label: this.$t('accounts.schedule.labels.timezone'),
          required: true,
          type: 'timezone',
          errors: (this.error.timezone || []).map(e => () => e)
        }
      }
    },
    methods: {
      remove (item) {
        this.schedule = this.schedule.filter(e => e !== item)
      },
      add () {
        this.schedule = this.sort([
          ...this.schedule,
          { ...this.newTime }
        ])
        this.newTime = { day: null, from: null, to: null }
        this.modal = false
      },
      sort (items) {
        return items.filter(valid).sort((a, b) => {
          if (a.day === b.day) {
            return a.from.localeCompare(b.from)
          } else {
            return a.day - b.day
          }
        })
      },
      submit () {
        this.save({ data: {
          schedule: JSON.stringify(this.schedule.filter(valid)),
          timezone: this.timezone
        } })
          .catch(({ response }) => (this.error = (response || {}).data || {}))
      }
    }
  }
</script>

<style lang="stylus">

  .schedule-table .input-group--select {
    margin: 0
  }

  .schedule-table .input-group__details {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/Schedule.vue